var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"id":"col-loader"}},[_c('div',{staticClass:"loader-modal"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_c('p',[_vm._v("Cargando...")])],1),_c('div',{staticClass:"cover"})])}
var staticRenderFns = []

export { render, staticRenderFns }